import React, { FC, PropsWithChildren, useId } from 'react'
import classnames from 'classnames'
import { OptionProp } from '../OptionSelector.constant'
import { input, label } from './option-container.module.scss'

export type OptionContainerProps = {
  srOnly: boolean
  value: string
  displayName?: string
  inputClassName?: string
  labelClassName?: string
  disabled?: boolean
  onChange?: (value: string) => void
} & Pick<OptionProp, 'selectionSetId' | 'isSelected'>

export const OptionContainer: FC<PropsWithChildren<OptionContainerProps>> = ({
  children,
  value,
  displayName,
  isSelected,
  srOnly,
  disabled,
  selectionSetId,
  inputClassName,
  labelClassName,
  onChange,
}) => {
  const id = useId()
  return (
    <>
      <input
        data-testid={`option-container_${value}`}
        type="radio"
        id={id}
        className={classnames(input, inputClassName)}
        name={selectionSetId}
        checked={isSelected}
        onChange={() => {
          if (onChange) onChange(value)
        }}
        value={value}
        disabled={disabled}
      />
      <label htmlFor={id} className={classnames(label, labelClassName)}>
        {children}
        {srOnly ? <span className="sr-only">{displayName || value}</span> : null}
      </label>
    </>
  )
}
